/*
angelCake v3.0 (http://angelcake.executiveresults.ca)
Copyright 2018 Executive Results
Licensed under the MIT license
*/

/* 
WRAPPER FOR flatpickr.js
*/

angelCake.generateDateTimePicker = function(jQueryElem){
  jQueryElem.parent().addClass('formicon-calendar');
  jQueryElem.flatpickr({
    inline:false,
    enableTime: true,
    altInput: true,
    altFormat: jQueryElem.attr('date-display-format'),
    dateFormat: jQueryElem.attr('date-value-format')
  });
};

angelCake.generateDatePicker = function(jQueryElem){
  jQueryElem.parent().addClass('formicon-calendar');
  jQueryElem.flatpickr({
    inline:false,
    enableTime: false,
    altInput: true,
    altFormat: jQueryElem.attr('date-display-format'),
    dateFormat: jQueryElem.attr('date-value-format')
  });
};

angelCake.generateTimePicker = function(jQueryElem){
  jQueryElem.parent().addClass('formicon-clock');
  jQueryElem.flatpickr({
    inline:false,
    enableTime: true,
    altInput: true,
    noCalendar: true,
    altFormat: jQueryElem.attr('date-display-format'),
    dateFormat: jQueryElem.attr('date-value-format')
  });
};



head.ready("appJS", function() {
	$(document).ready(function() {
		$('[data-datetimepicker]').each(function(){
		  angelCake.generateDateTimePicker($(this));
		});
		$('[data-datepicker]').each(function(){
		  angelCake.generateDatePicker($(this));
		});
		$('[data-timepicker]').each(function(){
		  angelCake.generateTimePicker($(this));
		});
	});
});